import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { getEnachDataListByDate, UpdateNachHitDateByLoanId } from '../AdminActionCreator.component';
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

const itemsPerPage = 10;



export default function NachManagementDashboard({ admin }) {
    const dispatch = useDispatch();
    const { fromDate: reducerFrom, toDate: reducerTo } = useSelector(state => state.FilterReduce.commonFilters);

    const [loader, setLoader] = useState(false)
    const [payload, setPayload] = useState({
        fromDate: reducerFrom,
        toDate: reducerTo,
    })
    const [tableData, setTableData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [tableErrorPopup, setTableErrorPopup] = useState({ show: false, data: {} })
    const [UpdateNachPopup, setUpdateNachPopup] = useState({ show: false, data: {} })
    const [nachUpdateDate, setNachUpdateDate] = useState(InitalDate("toDate"))
    const [popupValue, setPopupValue] = useState({ show: false, data: '' })

    useEffect(() => {
        setPayload({
            fromDate: reducerFrom,
            toDate: reducerTo,
        })


    }, [reducerFrom, reducerTo]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
         dispatch({ type: FILTER_ACTION, payload: { [name]: e.target.value } });
        setPayload((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleapply = () => {
        getEnachDataListByDateAPI()
    }


    useEffect(() => {
        getEnachDataListByDateAPI()
    }, [])

    const getEnachDataListByDateAPI = () => {

        const sDate = moment(payload.fromDate).format('DD-MM-YYYY')
        const eDate = moment(payload.toDate).format('DD-MM-YYYY');
        setLoader(true)
        getEnachDataListByDate(sDate, eDate, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.data && callback?.data?.length > 0) {
                setcurrentPage(1)
                setTableData(callback?.data)
                filterationData(1, callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    const filterationData = (currentPageNo, TotalData) => {
        const startIndex = (currentPageNo - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = TotalData.slice(startIndex, endIndex);
        setFilteredData(paginatedData);
    }

    const handlePageChange = (e, value) => {
        setcurrentPage(value)
        filterationData(value, tableData)
    }

    const handleErrorPopup = (d) => {
        if (d?.showStatus == "failed") {
            setTableErrorPopup({ show: true, data: d })
        }
    }

    const closepopup = () => {
        setTableErrorPopup({ show: false, data: {} })
        setUpdateNachPopup({ show: false, data: {} })
        setNachUpdateDate(InitalDate("toDate"))
    }

    const handleUpdateNachDate = (d) => {
        setUpdateNachPopup({ show: true, data: d })
    }

    const handleUpdateDate = (d) => {
        const data = {
            "empId": admin?.emailId,
            "emiId": d?.emiId,
            "nachHitDate": moment(nachUpdateDate).format("DD-MM-YYYY")
        }
        setLoader(true)
        UpdateNachHitDateByLoanId(d.loanId, data, callback => {
            console.log(callback)
            setLoader(false)
            setPopupValue({ show: true, data: callback })
            removePopup()
        })
    }

    const closepopupError = () => {
        setPopupValue({ show: false, data: "" })
    }
    const removePopup = () => {
        setTimeout(() => {
            closepopupError()
        }, 5000)
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }

            {
                popupValue?.show ?
                    <Popup closePopup={closepopupError} popupStatus={popupValue?.data} />
                    : ''}
            <div className="container-fluid">
                <h3 className='text-center blue-text'>Nach Management</h3>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">Start Date</label>
                        <input type="date" className='form-control' name="fromDate" value={payload.fromDate} onChange={(e) => handleInputChange(e)} />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">End Date</label>
                        <input type="date" className='form-control' name="toDate" value={payload.toDate} onChange={(e) => handleInputChange(e)} />
                    </div>
                    <div className="col-sm-2 col-xs-8">
                        <button className='btn btn-primary' style={{ marginTop: '22px', padding: '10px' }} onClick={() => handleapply()}>Filter</button>
                    </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-xs-12">
                        <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 1px #ccc', borderRadius: '15px', paddingBottom: '1px' }}>

                            <div style={{ overflowX: 'auto' }}>
                                <table>
                                    <thead >
                                        <tr>
                                            <th className='text-center' style={{ minWidth: '100px' }}>Application Id</th>
                                            <th className='text-center' style={{ minWidth: '250px' }}>Name</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>Mobile Number</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>EMI Amount</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>Loan Status</th>
                                            <th className='text-center' style={{ minWidth: '200px' }}>Bank Name</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>Token Id</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>Payment Method</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>NACH Status</th>
                                            <th className='text-center' style={{ minWidth: '150px' }}>Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData?.map((data, index) => (
                                            <tr key={index}>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.applicationId}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.firstName}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.mobileNumber}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.emiAmount}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.loanStatus}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.bankName}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>{data?.tokenId}</td>
                                                <td className='text-center' style={{ padding: '10px' }}>

                                                    {data?.methodType !== null && data?.methodType !== undefined && data?.methodType !== "" ? data?.methodType?.charAt(0)?.toUpperCase() + data?.methodType?.slice(1) : "-"}
                                                </td>
                                                <td className='text-center' style={{ padding: '10px' }}>
                                                    <div style={{ padding: '10px', background: data?.showStatus == "failed" ? "red" : data?.showStatus == "paid" ? "green" : "", color: data?.showStatus == "failed" || data?.showStatus == "paid" ? "#fff" : "", fontWeight: data?.showStatus == "failed" || data?.showStatus == "paid" ? "700" : "400", display: 'inline-block', borderRadius: '6px', cursor: data?.showStatus == "failed" ? "pointer" : "" }} onClick={() => handleErrorPopup(data)}>
                                                        {data?.showStatus?.charAt(0)?.toUpperCase() + data?.showStatus.slice(1)}
                                                    </div>
                                                </td>
                                                <td className='text-center' style={{ padding: '10px' }}>
                                                    {
                                                        data?.showStatus == "failed" || data?.showStatus == "Not Hit" ?
                                                            <button className='btn btn-primary' onClick={() => handleUpdateNachDate(data)}>Update</button>
                                                            : ''}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ marginTop: '15px', marginBottom: '10px' }}>
                                <Pagination
                                    count={Math.ceil(tableData?.length / itemsPerPage)}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary" style={{ display: 'flex', justifyContent: 'end' }}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {
                tableErrorPopup?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '20%' }}>
                            <i onClick={() => closepopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>{tableErrorPopup?.data?.applicationId}</h4>
                                </div>
                            </div>
                            <div className="row from-group">
                                <div className="col-xs-12 col-xs-12">
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 1px #ccc', borderRadius: '15px', paddingBottom: '1px' }}>

                                        <div style={{ overflowX: 'auto' }}>
                                            <table>
                                                <thead >
                                                    <tr>
                                                        <th className='text-center' style={{ minWidth: '150px' }}>NACH Status</th>
                                                        <th className='text-center' style={{ minWidth: '150px' }}>Failure Reason</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr>
                                                        <td className='text-center' style={{ padding: '10px' }}>
                                                            {tableErrorPopup?.data?.showStatus?.charAt(0)?.toUpperCase() + tableErrorPopup?.data?.showStatus.slice(1)}
                                                        </td>
                                                        <td className='text-center' style={{ padding: '10px' }}>{tableErrorPopup?.data?.error || "-"}</td>

                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    : ''}
            {
                UpdateNachPopup?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '15%' }}>
                            <i onClick={() => closepopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h4 className="text-center" style={{ marginBottom: '20px' }}>Update NACH Hit Date ({UpdateNachPopup?.data?.applicationId})</h4>
                                </div>
                            </div>
                            <div className="row from-group" style={{ display: 'flex', justifyContent: 'center' }}>
                                <div className="col-xs-6 col-xs-12" >
                                    <input type='date' className='form-control' value={nachUpdateDate} onChange={(e) => setNachUpdateDate(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 text-center" style={{ marginTop: '20px' }}>
                                    <button className='btn btn-primary' onClick={() => handleUpdateDate(UpdateNachPopup?.data)}>Save</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    : ''}
        </>
    )
}
